import { TSubscription } from '@mopla/data-models';

import { TPageLayoutConfig } from './types';
import { useDTicketCTAConfig } from './useDTicketCTAConfig';
import { useDTicketInfoMessageConfig } from './useDTicketInfoMessageConfig';
import { useDTicketOptionsConfig } from './useDTicketOptionsConfig';
import { useDTicketSectionsVisibility } from './useDTicketSectionsVisibility';

interface IUsePageLayoutConfigParams {
	subscription: TSubscription;
	onRefresh: () => void;
	onEditPaymentMethod: () => void;
}

export const usePageLayoutConfig = ({
	subscription,
	onRefresh,
	onEditPaymentMethod,
}: IUsePageLayoutConfigParams): TPageLayoutConfig => {
	const infoMessage = useDTicketInfoMessageConfig(subscription);
	const options = useDTicketOptionsConfig(subscription);
	const { showLegalSection, showOptionsSection, showHelpSection } =
		useDTicketSectionsVisibility(subscription);
	const cta = useDTicketCTAConfig({
		subscription,
		onRefresh,
		onEditPaymentMethod,
	});

	return {
		infoMessage,
		showLegalSection,
		showOptionsSection,
		options,
		cta,
		showHelpSection,
	};
};
